// Attest (veterinary certificate) content configs.
// Each config corresponds to an id registered in webapp/src/stores/sale.js
// under the `forms` array with `type: 'attest'`.
//
// Shape:
//   id:                  number, matches entry in saleStore.forms
//   title:               string, large heading printed on the attest
//   subtitle:            string, optional smaller subtitle (empty string for none)
//   mainParagraph:       string, formal Norwegian paragraph that frames the attest
//   includeJournalFields: array of keys from { 'anamnese', 'findings',
//                        'diagnoses', 'treatment' }. AttestLayout maps these to
//                        the correct journal schema fields.
//   extraFields:         array of { label: string, blankLines: number (1-3) }.
//                        Each becomes a labelled blank line on the print output
//                        for the vet to write on by hand.

const attestConfigs = {
    201: {
        id: 201,
        title: 'AVLIVNINGSATTEST',
        subtitle: '',
        mainParagraph: 'Det attesteres herved at nedenfor beskrevne dyr ble avlivet på faglig forsvarlig måte og av dyrevernmessige hensyn, basert på veterinærens vurdering av dyrets tilstand.',
        includeJournalFields: ['anamnese', 'findings', 'diagnoses', 'treatment'],
        extraFields: [
            { label: 'Avlivningsdato', blankLines: 1 },
            { label: 'Avlivningssted', blankLines: 1 },
            { label: 'Avlivningsmetode', blankLines: 1 },
            { label: 'Dyrets vekt ved avliving', blankLines: 1 },
            { label: 'Vitne', blankLines: 2 },
        ],
    },

    202: {
        id: 202,
        title: 'HELSEATTEST',
        subtitle: '',
        mainParagraph: 'Det attesteres herved at nedenfor beskrevne dyr er klinisk undersøkt på nedenstående dato og, basert på denne undersøkelsen, vurderes å være ved god helse.',
        includeJournalFields: [],
        extraFields: [
            { label: 'Formål med attest (salg/transport/utstilling/annet)', blankLines: 1 },
            { label: 'Undersøkelsesdato', blankLines: 1 },
            { label: 'Klinisk funn', blankLines: 3 },
            { label: 'Vaksinasjonsstatus', blankLines: 2 },
            { label: 'Parasittbehandling', blankLines: 1 },
            { label: 'Attesten er gyldig t.o.m.', blankLines: 1 },
        ],
    },

    203: {
        id: 203,
        title: 'DØDSATTEST',
        subtitle: '',
        mainParagraph: 'Det attesteres herved at nedenfor beskrevne dyr er dødt. Opplysninger om dødstidspunkt og antatt dødsårsak er oppgitt av dyreholder og/eller fastsatt ved veterinærens undersøkelse.',
        includeJournalFields: ['anamnese', 'findings', 'diagnoses'],
        extraFields: [
            { label: 'Dødsdato', blankLines: 1 },
            { label: 'Dødssted', blankLines: 1 },
            { label: 'Antatt dødsårsak', blankLines: 2 },
            { label: 'Patologiske funn', blankLines: 3 },
        ],
    },

    204: {
        id: 204,
        title: 'VETERINÆRATTEST TIL FORSIKRINGSSELSKAP',
        subtitle: '',
        mainParagraph: 'Etter anmodning fra dyreholder avgis herved veterinærfaglig uttalelse til bruk i forsikringssak. Opplysninger nedenfor er hentet fra dyrets journal.',
        includeJournalFields: ['anamnese', 'findings', 'diagnoses', 'treatment'],
        extraFields: [
            { label: 'Forsikringsselskap', blankLines: 1 },
            { label: 'Polisenummer', blankLines: 1 },
            { label: 'Skadenummer', blankLines: 1 },
            { label: 'Estimert behandlingskostnad', blankLines: 1 },
            { label: 'Prognose', blankLines: 2 },
            { label: 'Tilleggsopplysninger', blankLines: 3 },
        ],
    },

    205: {
        id: 205,
        title: 'KASTRERINGSATTEST',
        subtitle: '',
        mainParagraph: 'Det attesteres herved at nedenfor beskrevne dyr er kastrert av underskrivende veterinær.',
        includeJournalFields: [],
        extraFields: [
            { label: 'Kastreringsdato', blankLines: 1 },
            { label: 'Metode (kirurgisk/kjemisk)', blankLines: 1 },
            { label: 'Bedøvelse', blankLines: 1 },
            { label: 'Eventuelle komplikasjoner', blankLines: 2 },
        ],
    },

    206: {
        id: 206,
        title: 'DEKNINGS- OG DREKTIGHETSATTEST',
        subtitle: '',
        mainParagraph: 'Det attesteres herved at nedenfor beskrevne hunndyr er undersøkt og vurdert med hensyn til bedekning og/eller drektighet.',
        includeJournalFields: [],
        extraFields: [
            { label: 'Bedekningsdato', blankLines: 1 },
            { label: 'Hanndyrets navn', blankLines: 1 },
            { label: 'Hanndyrets chipId/registreringsnr', blankLines: 1 },
            { label: 'Drektighet bekreftet ved (metode)', blankLines: 1 },
            { label: 'Beregnet stadium (uke/måned)', blankLines: 1 },
            { label: 'Forventet fødselstermin', blankLines: 1 },
        ],
    },
};

export default attestConfigs;
